/**
 * Reducer helpers: Availability
 */

export const buildRequestState = oldState => {
  const newState = {
    ...oldState,
    data: {},
    meta: {
      requestDone: false,
      errorDetail: ''
    }
  }
  return newState
}

export const buildSuccessState = (oldState, payload) => {
  const newState = {
    ...oldState,
    data: payload,
    meta: {
      errorDetail: '',
      requestDone: true
    }
  }
  return newState
}

export const buildFailureState = (oldState, payload) => {
  const newState = {
    ...oldState,
    data: {},
    meta: {
      requestDone: true,
      errorDetail: payload
    }
  }
  return newState
}
